import { TextInput, Button, IconButton, BottomButton, MenuList, SelectOption } from 'components'
import { useRef, useState, useEffect } from 'react'
import useModal from 'hook/useModal'
import { userInfoState } from 'store/atom/user-state-atom'
import { useRecoilValue } from 'recoil'
import { useMenurecipCombo, useAddMenurecipImage } from 'api/menucrte/menurecip-fetch'
import { queryClient } from 'index'
import loadImage from 'blueimp-load-image'
import 'assets/style/common.scss'
import 'assets/style/components/img-register.scss'
import { isEmptyString, validFileExt } from 'utils/common-util'

export default function ImageRegist({ data }) {
  const userInfo = useRecoilValue(userInfoState)
  const { alertModal, closeModal, confirmModal, openRelateMenu } = useModal()

  const inputFileRef = useRef(null)
  const [isInit, setIsInit] = useState(false)
  const [file, setFile] = useState(null)
  const [imgSrc, setImgSrc] = useState('')
  const [searchKeyword, setSearchKeyword] = useState('')
  const [menu, setMenu] = useState()
  const [selected, setSelected] = useState(data?.menuIdSeq)

  const { data: combo, refetch } = useMenurecipCombo(menu, isInit)
  const addMenurecipImage = useAddMenurecipImage({
    successHandler: () => {
      closeModal()
      alertModal('저장되었습니다.')
    },
    errorHandler: () => {},
  })

  useEffect(() => {
    console.log(data)
    if (data?.menuIdSeq) {
      const temp = data.menuIdSeq.split('|')
      const menuId = temp[0]
      const menuSeq = temp[1]
      const siteId = temp[2]
      setMenu({
        menuId: menuId,
        menuSeq: menuSeq,
        siteId: siteId,
        coId: userInfo.coId,
        userId: userInfo.userId,
        mySiteId: userInfo.siteId,
        skip: 'N',
      })
    }

    return () => {
      queryClient.removeQueries('menurecipCombo')
    }
  }, [])

  // useEffect(() => {
  //   if (file) {
  //     encodeFileToBase64(file)
  //   }
  // }, [file])

  useEffect(() => {
    if (menu) {
      refetch()
    }
  }, [menu])

  const addFile = (e) => {
    const element = e.target
    const file = element.files && element.files[0]
    if (!validFileExt(file)) {
      alertModal('이미지파일만 첨부가능합니다.')
      return
    }

    if (file) {
      loadImage(
        file,
        function (img, data) {
          if (img.type === 'error') {
            alertModal('이미지파일을 확인해 주세요.')
            return
          }

          // 1. 이미지 파일 데이터에 imageHead와 exif가 있는지 확인
          setImgSrc(img.toDataURL())
          if (data.imageHead && data.exif) {
            // 2. exif 값이 있다면 orientation 값을 1로 변경
            loadImage.writeExifData(data.imageHead, data, 'Orientation', 1)
            img.toBlob(function (blob) {
              loadImage.replaceHead(blob, data.imageHead, async function (newBlob) {
                newBlob.name = file.name
                newBlob.lastModifiedDate = new Date()
                const imgFile = new File([newBlob], file.name, {
                  type: newBlob.type,
                  lastModifiedDate: new Date(),
                })
                setFile(() => imgFile)
              })
            }, 'image/jpeg')
          } else {
            setFile(() => file)
          }
          e.target.value = ''
        },
        { meta: true, orientation: true, canvas: true },
      )
    }
  }

  // const encodeFileToBase64 = (fileBlob) => {
  //   const reader = new FileReader()
  //   reader.readAsDataURL(fileBlob)
  //   return new Promise((resolve) => {
  //     reader.onload = () => {
  //       setImgSrc(reader.result)
  //       resolve()
  //     }
  //   })
  // }

  const selectedMenu = (menu) => {
    setMenu({ ...menu, coId: userInfo.coId, userId: userInfo.userId, mySiteId: userInfo.siteId, skip: 'N' })
  }

  const saveImage = () => {
    if (isEmptyString(selected)) {
      alertModal('사이트레시피를 선택해주세요.')
      return
    } else if (file === null) {
      alertModal('이미지를 선택해주세요.')
      return
    }

    const temp = selected.split('|')
    const menuId = temp[0]
    const menuSeq = temp[1]
    const siteId = temp[2]

    confirmModal('저장 하시겠습니까?', () => {
      closeModal()
      const formData = new FormData()
      formData.append('coId', userInfo.coId)
      formData.append('siteId', siteId)
      formData.append('menuId', menuId)
      formData.append('menuSeq', menuSeq)
      formData.append('attachImages', file)

      if (data?.attchFileSerno) {
        formData.append('attchFileSerno', data.attchFileSerno)
      }

      addMenurecipImage.mutate(formData)
    })
  }
  return (
    <>
      <div className="wrapper img-register" style={{ marginBottom: '68px' }}>
        {/* todo: 팝업헤더 */}
        {file ? (
          <div className="img-box flex-align-center mt16">
            <img
              src={imgSrc}
              style={{ height: '100%' }}
              onClick={() => {
                setFile(null)
                setImgSrc('')
              }}
            />
            {imgSrc === '' && (
              <IconButton
                className="add-gray"
                size="48"
                onClick={() => {
                  setFile(null)
                  setImgSrc('')
                }}
              />
            )}
          </div>
        ) : (
          <div className="img-box flex-align-center mt16">
            <input type="file" accept="image/*" ref={inputFileRef} style={{ display: 'none' }} onChange={addFile} />
            <IconButton
              className="add-gray"
              size="48"
              onClick={() => {
                inputFileRef.current.click()
              }}
            />
          </div>
        )}
        {/* <InputCheckbox title="대표이미지로 선택" name="c1" className="mt18" /> */}
        {isEmptyString(data?.menuIdSeq) && (
          <div className="flex-between mt26">
            <TextInput
              removeable="true"
              value={searchKeyword}
              onChange={(e) => setSearchKeyword(e.target.value)}
              placeholder="한글메뉴별칭(영문메뉴별칭)"
              onKeyUp={(e) => {
                console.log(e)
                if (e.key === 'Enter') {
                  openRelateMenu(searchKeyword, '20', (result) => {
                    closeModal()
                    selectedMenu(result)
                  })
                }
              }}
            />
            <Button
              text="메뉴검색"
              color="outline"
              className="ml8"
              onClick={() =>
                openRelateMenu(searchKeyword, '20', (result) => {
                  closeModal()
                  selectedMenu(result)
                })
              }
            />
          </div>
        )}
        {menu && (
          <div>
            {isEmptyString(data?.menuIdSeq) && <MenuList className="mt8" datas={[menu]} isDispImg={false} />}
            {combo && (
              <div className="mt4 mb18 flex-between">
                <SelectOption
                  root={'선택안함'}
                  value={selected}
                  disabled={data?.menuIdSeq ? true : false}
                  list={combo.menuIdList.filter((item) => item.menuIdSeq.split('|')[3] === 'M')}
                  textKey={'menuNm'}
                  valueKey={'menuIdSeq'}
                  onChange={(e) => setSelected(e.target.value)}
                />
              </div>
            )}
          </div>
        )}
      </div>

      <BottomButton data={[{ title: '이미지 등록', color: 'primary' }]} onClick={saveImage} />
    </>
  )
}
